import './index.styl';

import { CollectionView } from 'backbone.marionette';
import { Tipping } from '../../../collections';
import { FormGuide, User } from '../../../models';
import TipView from '../Tip/index';
import _ from 'lodash';
import { ErrorsModal } from '../../../utils';
import Radio from 'backbone.radio';
import TipFinView from '../TipFin';

const
	moment = require('moment'),
	withCurrency = num => `$${Math.round10(num, -2).toFixed(2)}`,
	tippingRadio = Radio.channel('tipping');

export class TipsCollection extends CollectionView {

	className() {
		return 'tipping-tips-collection';
	}

	initialize() {

		this.collection = new Tipping();
		this.selected_round_id = undefined;
		this.is_final = false;

		this.updateTips = _.debounce(this.updateTips, 1000);

		this.listenTo(tippingRadio, 'save', this.updateTips);
		this.listenTo(this.collection, 'update:tips:success', () => tippingRadio.trigger('saved'));
		this.listenTo(this.collection, 'update:tips:errors', ErrorsModal.show);
	}

	get childView() {
		if(this.is_final) {
			return TipFinView;
		}
		else {
			return TipView;
		}

	}

	childViewOptions(model) {
		model.set({ is_adult: User.is_adult, round_name: '' }, { silent: true });

		return {
			game_info: new FormGuide({
				id: model.get('id')
			})
		}
	}

	childViewEvents() {
		return {
			'make:bet': 'updateTips',
		}
	}

	init({ user_tips, selected_round_id, is_final }) {
		const tips = _.chain(user_tips)
			.values()
			.map(tip => ({
				...tip,
				game_date: moment(tip.date).format('ddd, Do MMM h:mma'),
				image_squads_path: process.env.SQUAD_LOGOS_PATH,
				home_squad_odds_currency: withCurrency(tip.home_squad_odds),
				away_squad_odds_currency: withCurrency(tip.away_squad_odds),
				home_squad_id: parseInt(tip.home_squad_id, 10),
				away_squad_id: parseInt(tip.away_squad_id, 10),
				is_disabled: tip.status !== 'scheduled',
				is_completed: tip.status === 'complete',
				is_live: tip.status === 'playing',
				is_odds_visible: (
					tip.home_squad_odds && tip.away_squad_odds && tip.status !== 'complete'
				)
			}))
			.value();

		this.selected_round_id = selected_round_id;
		this.is_final = is_final;
		this.collection.reset(tips);
	}

	async updateTips() {
		const
			tips = this.collection.selected_tips_post_data,
			selected_tips_count = _.size(tips),
			is_final = this.is_final;
		
		if (!selected_tips_count) {
			return;
		}

		const { errors } = await this.collection.checkIsFinal(is_final)
			.setAddUrl()
			.postData({
				data: { tips },
				// type: 'update:tips'
			});
		tippingRadio.trigger('changed');

		if (_.size(errors)) {
			tippingRadio.trigger('change:round', { round_id: this.selected_round_id });

			const error = [{
				text: 'We could not save your tip. Check your internet connection & try again'
			}];

			return this.collection.trigger('update:tips:errors', error);
		}

		tippingRadio.trigger('tips:count', { selected_tips_count });
		tippingRadio.trigger('user:tips', this.collection.selected_tips);

		this.collection.trigger('update:tips:success');
	}
}

export default TipsCollection;